import close from "../assets/images/close.svg";
import { useState } from "react";

const CategoryListTab = ({
  handleshowPopup,
  categoryList,
  handleCategoryClick,
  selectedCategory,
}) => {
  const getCategoryList = () => {
    let updatedData = categoryList?.filter((x, i) => i > 4);
    return updatedData;
  };

  const [tabList, setTabList] = useState(getCategoryList());

  return (
    <div className="category-other-tabs-menu-container">
      <div className="category-other-tabs-menu-main">
        <img
          src={close}
          alt="close"
          id="service-menu"
          className="cursor-pointer service-close"
          onClick={(e) => {
            handleshowPopup(e);
          }}
        />
        <div className="category-other-tabs-menu-all-services">
          <div className="category-other-tabs-menu-service-bunch">
            <div className="category-other-tabs-menu-single-service">
              <div className="category-other-tabs-menu-sevice-content">
                <ul>
                  {tabList?.map((item, index) => {
                    return (
                      <li
                        key={item?.categoryid}
                        onClick={(e) => {
                          handleCategoryClick(
                            index + 5,
                            item?.categoryid,
                            item?.categoryname
                          );
                          handleshowPopup(e);
                        }}
                      >
                        <span
                          className={`${
                            selectedCategory === index + 5
                              ? "other-tab-active"
                              : ""
                          }`}
                        >
                          {item?.categoryname}
                        </span>
                      </li>
                    );
                  })}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CategoryListTab;
